import React from "react";
import { EmptyState, QueryResult } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { useGetComponentSignaturesQuery } from "../../services/fileBrowser.api";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import CertificateMetadata from "./certificateMetadata/CertificateMetadata";
import CounterSignerChain from "./counterSignerChain/CounterSignerChain";
import SelectorTabs from "./selectorTabs/SelectorTabs";
import styles from "./signatures.module.scss";
import SignerChain from "./signerChain/SignerChain";
import useSignature from "./useSignature";
const Signatures = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { fileId, reportId } = useGetFileAndReportId();
    const { data, isLoading, isFetching, isError, error } = useGetComponentSignaturesQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const { signatureState, handleSelectSignature, handleSelectCertificate, handleSelectDanglingCertificate, } = useSignature();
    const selectedSignature = signatureState.signatureIndex !== undefined &&
        signatureState.signatureIndex < ((_a = data === null || data === void 0 ? void 0 : data.signatures.length) !== null && _a !== void 0 ? _a : 0)
        ? data === null || data === void 0 ? void 0 : data.signatures[signatureState.signatureIndex]
        : undefined;
    // Preselect first signature or dangling certificate if no signature or dangling certificate is selected
    if (Object.keys((_b = data === null || data === void 0 ? void 0 : data.certificates) !== null && _b !== void 0 ? _b : {}).length > 0 &&
        signatureState.signatureIndex === undefined &&
        signatureState.danglingCertificateIndex === undefined) {
        if (data === null || data === void 0 ? void 0 : data.signatures[0]) {
            handleSelectSignature(0, (_c = data.signatures[0].signature.cert_chain[0][1]) !== null && _c !== void 0 ? _c : "");
        }
        else if (data === null || data === void 0 ? void 0 : data.dangling_certificates[0]) {
            handleSelectDanglingCertificate(0, data.dangling_certificates[0]);
        }
    }
    let certValidation = undefined;
    if (selectedSignature && signatureState.certificateId) {
        if (signatureState.counterSignatureIndex !== undefined) {
            certValidation =
                selectedSignature.counter_signatures[signatureState.counterSignatureIndex].signature.cert_validation[signatureState.certificateId];
        }
        else {
            certValidation =
                selectedSignature.signature.cert_validation[signatureState.certificateId];
        }
    }
    if (data && Object.keys(data.certificates).length === 0) {
        return React.createElement(EmptyState, { subject: "signatures" });
    }
    return (React.createElement(QueryResult, { status: getQueryStatus({ data, isLoading, isFetching, isError, error }) },
        React.createElement("div", { className: styles.root },
            React.createElement(SelectorTabs, { signatureState: signatureState, signatures: (_d = data === null || data === void 0 ? void 0 : data.signatures) !== null && _d !== void 0 ? _d : [], dangling_certificates: (_e = data === null || data === void 0 ? void 0 : data.dangling_certificates) !== null && _e !== void 0 ? _e : [], certificates: (_f = data === null || data === void 0 ? void 0 : data.certificates) !== null && _f !== void 0 ? _f : {}, onSelectSignature: handleSelectSignature, onSelectDanglingCertificate: handleSelectDanglingCertificate }),
            React.createElement("div", { className: styles["certificate-chains"] }, selectedSignature ? (React.createElement(React.Fragment, null,
                React.createElement(SignerChain, { signature: selectedSignature, certificates: (_g = data === null || data === void 0 ? void 0 : data.certificates) !== null && _g !== void 0 ? _g : {}, selectedCertificateId: signatureState.chain === "signer"
                        ? signatureState.certificateId
                        : undefined, onSelectCertificate: (certificateId) => handleSelectCertificate(certificateId, "signer", undefined) }),
                React.createElement(CounterSignerChain, { counterSignatures: selectedSignature.counter_signatures, certificates: (_h = data === null || data === void 0 ? void 0 : data.certificates) !== null && _h !== void 0 ? _h : {}, selectedCertificateId: signatureState.chain === "counter-signer"
                        ? signatureState.certificateId
                        : undefined, onSelectCertificate: (certificateId, counterSignatureIndex) => handleSelectCertificate(certificateId, "counter-signer", counterSignatureIndex) }))) : null),
            signatureState.certificateId &&
                (data === null || data === void 0 ? void 0 : data.certificates[signatureState.certificateId]) && (React.createElement(CertificateMetadata, { certificate: data.certificates[signatureState.certificateId], validation: certValidation })))));
};
export default Signatures;
//# sourceMappingURL=Signatures.js.map